import { z } from "zod";

export const credentialSchema = z.object({
  email: z.string().email("Format email salah"),
  password: z.string().min(6, "Password must be at least 6 characters"),
});
